<form [formGroup]="payloadContentForm">
  <div class="d-flex">
    <h5 class="mt-auto small-caps">Payload</h5>
    @if (allowToggle()) {
      <button type="button"
              class="btn btn-outline-primary border-0 ms-auto"
              (click)="toggleEditing()">
        @if (!editing) {
          <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
        } @else {
          <fa-icon [icon]="['far', 'save']"></fa-icon>
        }
      </button>
    }
  </div>
  <table class="table table-sm table-list mb-4">
    <thead>
      <tr>
        <th colspan="2"
            scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <!-- PayloadType -->
      <tr>
        <th title="The payload type. The payload types are described in Payload-Specific Property Keys. https://developer.apple.com/library/archive/featuredarticles/iPhoneConfigurationProfileRef/Introduction/Introduction.html#//apple_ref/doc/uid/TP40010206-CH1-SW2"
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadType"
                 class="col-form-label">Payload Type</label>
        </th>
        <td>
          <label for="payloadType"
                 class="col-form-label">{{ payloadContent()?.payloadType }}</label>
        </td>
      </tr>

      <!-- PayloadVersion -->
      <tr>
        <th title="The version number of the individual payload.
              A profile can consist of payloads with different version numbers. For example, changes to the VPN software in iOS might introduce a new payload version to support additional features, but Mail payload versions would not necessarily change in the same release."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadVersion"
                 class="col-form-label">Payload Version</label>
        </th>
        <td>
          <label for="payloadVersion"
                 class="col-form-label">{{ payloadContent()?.payloadVersion }}</label>
        </td>
      </tr>

      <!-- PayloadIdentifier -->
      <tr>
        <th title="A reverse-DNS-style identifier for the specific payload. It is usually the same identifier as the root-level PayloadIdentifier value with an additional component appended."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadIdentifier"
                 class="col-form-label">Payload Identifier</label>
        </th>
        <td>
          <label for="payloadIdentifier"
                 class="col-form-label">{{ payloadContent()?.payloadIdentifier }}</label>
        </td>
      </tr>

      <!-- PayloadUUID -->
      <tr>
        <th title="A globally unique identifier for the payload. The actual content is unimportant, but it must be globally unique. In macOS, you can use uuidgen to generate reasonable UUIDs."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadUUID"
                 class="col-form-label">Payload UUID</label>
        </th>
        <td>
          <label for="payloadUUID"
                 class="col-form-label">{{ payloadContent()?.payloadUUID }}</label>
        </td>
      </tr>

      <!-- PayloadDisplayName -->
      <tr>
        <th title="A human-readable name for the profile. This value is displayed on the Detail screen. It does not have to be unique."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadDisplayName"
                 class="col-form-label">Payload Display Name</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadDisplayName"
                   class="col-form-label">{{ payloadContent()?.payloadDisplayName }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadDisplayName"
                   formControlName="payloadDisplayName" />
          }
        </td>
      </tr>

      <!-- PayloadDescription -->
      <tr>
        <th title="Optional. A human-readable description of this payload. This description is shown on the Detail screen."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadDescription"
                 class="col-form-label">Payload Description</label>
        </th>
        <td>
          @if (!editing) {
            <label for="payloadDescription"
                   class="col-form-label">{{ payloadContent()?.payloadDescription }}</label>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadDescription"
                   formControlName="payloadDescription" />
          }
        </td>
      </tr>

      <!-- PayloadOrganization -->
      <tr>
        <th title="Optional. A human-readable string containing the name of the organization that provided the profile. The payload organization for a payload need not match the payload organization in the enclosing profile."
            data-toggle="tooltip"
            data-placement="right"
            scope="row">
          <label for="payloadOrganization"
                 class="col-form-label">Payload Organization</label>
        </th>
        <td>
          @if (!editing) {
            <span class="col-form-label">{{ payloadContent()?.payloadOrganization }}</span>
          } @else {
            <input type="text"
                   class="form-control"
                   id="payloadOrganization"
                   formControlName="payloadOrganization" />
          }
        </td>
      </tr>
    </tbody>
  </table>
</form>